import { lowerFirst } from 'lodash';
import { type RecordLayoutKey } from './shared-types';

// This must match Aha.CardLayoutRecordTypesEnum
const RECORD_TYPES_WITH_CARD_LAYOUTS = [
  'Epic',
  'Feature',
  'Idea',
  'Initiative',
  'Release',
  'ReleasePhase',
  'Requirement',
  'Task',
  'Goal',
] as const;

export type RecordTypesWithCardLayouts =
  (typeof RECORD_TYPES_WITH_CARD_LAYOUTS)[number];

export const recordLayoutKey = (
  recordType: RecordTypesWithCardLayouts
): RecordLayoutKey => `${lowerFirst(recordType)}RecordLayout`;

export type CardLayoutConfigurationData = Partial<
  Record<RecordLayoutKey, Partial<Aha.RecordLayoutAttributes> | null>
>;

export const recordTypeHasCardLayout = (
  recordType: string
): recordType is RecordTypesWithCardLayouts =>
  RECORD_TYPES_WITH_CARD_LAYOUTS.includes(recordType);
